// import ActionType from 'actions/ActionType'

export default (state = {}, action) => {
  switch (action.type) {
    // case ActionType.Data.LIST_SUCCESS:
    // if (action.entityType === 'campaign') {
    //   return action.payload?.reduce((acc, el) => {
    //     const stageIDs = el.stages?.reduce((stageAcc, stage) => {})
    //     return acc
    //   }, {})
    // }
    // return state
    default:
      return state
  }
}
